import { Dialog } from "../../../../components/modal/Dialog";
import { SellarCreditCheckDialogContent } from "./components/SellarCreditCheckDialogContent/SellarCreditCheckDialogContent";
import { SellarCreditTwoDialogPageEnum } from "./components/SellarCreditCheckDialogContent/TwoSellarCreditCheckDialogContent/types/SellarCreditTwoDialogPageEnum";

export const SellarCreditCheckDialog = ({
  active,
  onDismiss,
}: {
  active: boolean;
  onDismiss: () => void;
}) => {
  return <TwoSellarCreditCheckDialog active={active} onDismiss={onDismiss} />;
};

export const TwoSellarCreditCheckDialog = ({
  active,
  onDismiss,
}: {
  active: boolean;
  onDismiss: () => void;
}) => {
  return (
    <Dialog
      active={active}
      fullHeight={true}
      onDismiss={onDismiss}
      initPage={SellarCreditTwoDialogPageEnum.WELCOME}
      className="rounded-none md:max-h-[768px] md:max-w-[480px] md:rounded-lg"
    >
      <SellarCreditCheckDialogContent onDismiss={onDismiss} />
    </Dialog>
  );
};
